export enum TranscribeTargetKinds {
  FreeText,
  Text,
  Check,
  CircleSelect,
}
